import { firebasePlatformConfig } from './platformConfig';
import { initializePlatformAuth } from './initializePlatformAuth';
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { setPersistence, browserLocalPersistence, inMemoryPersistence } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";

import { Capacitor } from '@capacitor/core';

const app = initializeApp(firebasePlatformConfig(Capacitor.isNativePlatform()));

// Initialize Firebase services
export const auth = initializePlatformAuth(app, Capacitor.isNativePlatform(), Capacitor.getPlatform()==='ios');
export const db = getFirestore(app);

// Point at emulators when requested (run: firebase emulators:start --only functions,firestore)
if (process.env.REACT_APP_USE_EMULATORS === 'true') {
  connectFirestoreEmulator(db, '127.0.0.1', 8080);
}

// Remove legacy persisted iOS auth after switching to a secure enrollment flow.
if(Capacitor.getPlatform()==='ios'){
 localStorage.removeItem('finflow_auth');
 const authKey=`firebase:authUser:${app.options.apiKey}:${app.name}`;
 localStorage.removeItem(authKey);
}
// Set persistence immediately for better session management
setPersistence(auth, Capacitor.getPlatform()==='ios'?inMemoryPersistence:browserLocalPersistence)
  .then(() => {
    console.log('✅ Firebase auth persistence set to local');
  })
  .catch((error) => {
    console.error('❌ Failed to set Firebase persistence:', error);
  });

// Add a function to check if Firebase is ready
export const isFirebaseReady = () => {
  return auth && db && auth.app && db.app;
};

// Website analytics is initialized only by the consent-gated tag in public/index.html.
// Keep this legacy export inert; Firebase Auth/Firestore must not start another tag.
const analytics = undefined;

// iOS-specific configuration
if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios') {
  // Add iOS-specific error handling
  auth.onAuthStateChanged((user) => {
    if (user) {
      // User is signed in
    } else {
      // User is signed out
    }
  }, (error) => {
    console.error('❌ iOS Auth state change error:', error);
  });

  // Add network status monitoring for iOS
  if (typeof window !== 'undefined') {
    window.addEventListener('online', () => {
      // Network is back online
    });
    
    window.addEventListener('offline', () => {
      // Network is offline
    });
  }
}

export { analytics };
export default app; 